import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromInvoiceChargeNumber from './invoice-charge-number.reducer';

export const selectInvoiceChargeNumberState = createFeatureSelector<fromInvoiceChargeNumber.State>(
    fromInvoiceChargeNumber.invoiceChargeNumbersFeatureKey
);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromInvoiceChargeNumber.adapter.getSelectors(
    selectInvoiceChargeNumberState
);
